import firebase from "firebase/app";
import "firebase/database";

const config = {
  apiKey: "AIzaSyBW4nJBEBQB7lXoPh6N0JUny5i8PJrZHFs",
  authDomain: "datahodor.firebaseapp.com",
  databaseURL: "https://datahodor.firebaseio.com",
  projectId: "datahodor",
  storageBucket: "datahodor.appspot.com",
  messagingSenderId: "169369624095",
  appId: "1:169369624095:web:94aedc6035a125be047f2a",
  measurementId: "G-9GBP4G8CTS",
};

firebase.initializeApp(config);
export const _Database = firebase.database();

export default _Database;
